module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/gq-89421f59da9e40d8cfccac2479092421.svg";